<template>
    <van-form class="EvaluateContainer">
        <van-field name="service_score" label="服务">
            <template #input>
                <van-rate
                    v-model="formData.service_score"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    allow-half
                />
            </template>
        </van-field>

        <van-field name="efficiency_score" label="效率">
            <template #input>
                <van-rate
                    v-model="formData.efficiency_score"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    allow-half
                />
            </template>
        </van-field>

        <van-field name="store_score" label="门店">
            <template #input>
                <van-rate
                    v-model="formData.store_score"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    allow-half
                />
            </template>
        </van-field>


        <van-field
            v-model="formData.evaluate"
            rows="3"
            autosize
            type="textarea"
            placeholder="请输入评论"
            style="margin: 20px 0;"
        />


        <van-uploader
            style="margin: 20px 0;"
            v-model="image.fileList" 
            multiple 
            class="UploadImage"
			:max-count="9"
           >
        </van-uploader>



        <div style="display: flex;justify-content: center;margin:0.6rem 0;">
            <van-button type="info" class="SubmitBtn" @click="save">提交</van-button>
        </div>

    </van-form>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "Evaluate",
        data(){
            return {
                isLoading: false,
                formData: {
                    order_no: '',
                    evaluate: '',
                    service_score: 0,
                    efficiency_score: 0,
                    store_score: 0,
                    images: ''
                },
                image: {
                    file: '',
                    fileList: []
                },
            };
        },
        created() {
            if (this.$route.query.order_no) {
                this.formData.order_no = this.$route.query.order_no;
            } else {
                this.$router.back();
                this.$toast.fail('发生错误，无法获取订单号');
            }
        },
        methods : {
            save(){
                let self = this;
                if (this.isLoading) return;
                this.isLoading = true;
                let loading = this.$toast.loading({
                    message: '提交中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
 
                if (self.image.fileList.length > 0) {
                    let fromData = new FormData();
                    let files = []
                    self.image.fileList.forEach((f, index) => {
						fromData.append(`file[${index}]`, f.file);
                    }) 
                    api.request('/common/multiple_image_upload', fromData).then(res => {
                        api.request('/order/evaluate', Object.assign({}, self.formData, {images: res.data.group_id})).then(res => {
                            self.$toast(res.msg);
                            self.$router.back();
                            self.$toast.clear(loading);
                        }).catch(res => {
                            self.$toast.clear(loading);
                            self.$toast.fail(res.msg);
                        }).finally(() => {
                            self.isLoading = false;
                        });
                    }).catch(err => {
                        self.$toast.fail(err);
                    })
                } else {
                    api.request('/order/evaluate', self.formData).then(res => {
                        self.$toast(res.msg);
                        self.$router.back();
                        self.$toast.clear(loading);
                    }).catch(res => {
                        self.$toast.clear(loading);
                        self.$toast.fail(res.msg);
                    }).finally(() => {
                        self.isLoading = false;
                    });
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

    .EvaluateContainer {
        box-sizing: border-box;
        margin: 10px;
        background: #fff;

        .FormContainer {
            background: #fff;
            display: flex;
            align-items: center;
            &::before {
                position: absolute;
                left: 0.21333rem;
                color: #ee0a24;
                font-size: 0.37333rem;
                content: '*';
            }
        }
        .FormLabel {
            -webkit-box-flex: 0;
            -webkit-flex: none;
            flex: none;
            box-sizing: border-box;
            margin-left: 16px;
            width: 6.2em;
            margin-right: 0.32rem;
            color: #646566;
            text-align: left;
        }

        .UploadImage {
            width: 100%;
            box-sizing: border-box;
            padding: 0 10px;

            .van-uploader__upload {
                width: 33%!important;
            }
        }

        .DisplaySpan {
            text-align: center;
            display:block;
            font-size: 0.4rem;
            color: #666;
            padding: 0.4rem;
        }

        .SubmitBtn {
            margin: 20px 0;
            width: 75vw;
            border-radius: 0.3rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/Evaluate.vue